import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import { Grid, Typography } from "@mui/material";
import { DivRootStyled, SearchInputStyled } from "./CredentialRequestsToolbar.styles";
const CredentialRequestsToolbar = (props) => {
  const { className, handleSearch, intl } = props;
  return /* @__PURE__ */ React.createElement(DivRootStyled, { className }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 3 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "menu.credentialsRequests" }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4 }, /* @__PURE__ */ React.createElement(
    SearchInputStyled,
    {
      onChange: handleSearch,
      placeholder: intl.formatMessage({ id: "credentialRequests.search" }).toUpperCase()
    }
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4, sx: { display: "flex", justifyContent: "flex-end" } })));
};
CredentialRequestsToolbar.propTypes = {
  className: PropTypes.string,
  handleSearch: PropTypes.func.isRequired
};
export default injectIntl(CredentialRequestsToolbar);
